import { combineReducers } from 'redux'
import AdminById from './state/AdminById/reducer'
import Auth from './state/Auth/reducer'
import Clock from './state/Clock/reducer'
import DeviceById from './state/DeviceById/reducer'
import LogCountById from './state/LogCountById/reducer'
import LoginForm from './state/LoginForm/reducer'
import SessionById from './state/SessionById/reducer'
import SystemCache from './state/SystemCache/reducer'
import UserById from './state/UserById/reducer'

import { State } from './types'

export default combineReducers<State>({
  Auth,
  Clock,
  DeviceById,
  LogCountById,
  LoginForm,
  SessionById,
  UserById,
  AdminById,
  SystemCache,
})
